import Cookies from 'universal-cookie'; const cookies = new Cookies();
function BackToPortal() {
    var sessionToken = cookies.get('sessionToken', { path: '/' })
    //VM1 sets REACT_APP_BACK_TO_PORTAL_DESTINATION; without it the link uses the portal address as before
    window.location.replace((process.env.REACT_APP_BACK_TO_PORTAL_DESTINATION || process.env.REACT_APP_PORTAL_DESTINATION) + "api/dashboard/" + sessionToken);
}

export default BackToPortal